'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'bomb';
var width = 576;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M400 64c0 6.9 4.4 13 10.9 15.2l40.4 13.5 13.5 40.4c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l13.5-40.4 40.4-13.5C555.6 77 560 70.9 560 64s-4.4-13-10.9-15.2L508.6 35.4 495.2-5.1C493-11.6 486.9-16 480-16s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C404.4 51 400 57.1 400 64z', 'M321.4 97.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-10.9 10.9c7.9 22 12.2 45.7 12.2 70.5 0 114.9-93.1 208-208 208S32 418.9 32 304 125.1 96 240 96c24.7 0 48.5 4.3 70.5 12.3l10.9-10.9zM144 304c0-53 43-96 96-96 13.3 0 24-10.7 24-24s-10.7-24-24-24c-79.5 0-144 64.5-144 144 0 13.3 10.7 24 24 24s24-10.7 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;